import React, { useEffect, useState } from 'react';

import Box from '@mui/material/Box';
import FilterAltOffOutlinedIcon from '@mui/icons-material/FilterAltOffOutlined';

import Drawer from '../shared/Drawer';
import Autocomplete from '../shared/Autocomplete';
import Button from '../shared/Button';

const FilterLogisticsModal = (props) => {
  const {
    filter,
    open,
    onSubmit,
    onClose,
    logistics,
    countries,
  } = props;

  const [selectedCountries, setSelectedCountries] = useState([]);

  useEffect(() => {
    if (filter) {
      setSelectedCountries(filter.countries || []);
    }
  }, [open, filter, logistics]);

  const onClear = () => {
    setSelectedCountries([]);
  };

  const handleSubmit = () => {
    onSubmit({
      countries: selectedCountries,
    });
  }

  return (
    <Drawer
      open={open}
      onClose={onClose}
      onSubmit={handleSubmit}
      title="Filter Logistics"
      subtitle="Apply filters to find specific logistics"
      submitText="Submit"
    >
      <Box sx={{ minWidth: { xs: 'auto', md: '560px' }, maxWidth: '560px' }}>
        <Box>
          <Autocomplete
            value={selectedCountries}
            onChange={setSelectedCountries}
            options={countries}
            label="Country"
            multiple
          />
        </Box>
        <Button
          sx={{ mt: 2 }}
          text="Clear Filters"
          icon={<FilterAltOffOutlinedIcon />}
          onClick={onClear}
          type='secondary'
        />
      </Box>
    </Drawer>
  );
};

export default FilterLogisticsModal;
